import React, { useEffect, useState } from 'react';
import tripService from '../../services/tripService';
import StatCard from './StatCard';
import RecentTrips from './RecentTrips';
import Loader from '../common/Loader';
import { useAuth } from '../../hooks/useAuth';
import { useVehicles } from '../../hooks/useVehicles';

export default function DriverDashboard() {
  const { user } = useAuth();
  const { selectedVehicle, handleDriverScopeError } = useVehicles();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTodaySummary = async () => {
      setLoading(true);
      try {
        const totals = await tripService.summary();
        setSummary({
          total_revenue: Number(totals?.total_revenue || 0),
          total_expenses: Number(totals?.total_expenses || 0),
          total_trips: Number(totals?.total_trips || 0),
        });
      } catch (err) {
        handleDriverScopeError(err);
        setSummary(null);
      } finally {
        setLoading(false);
      }
    };

    loadTodaySummary();
  }, [user, selectedVehicle, handleDriverScopeError]);

  if (loading) return <Loader />;

  return (
    <div>
      <div className="grid-3" style={{ marginBottom: '1.5rem' }}>
        <StatCard label="My Revenue Today" value={summary?.total_revenue} type="currency" accent />
        <StatCard label="My Expenses Today" value={summary?.total_expenses} type="currency" />
        <StatCard label="Trips Today" value={summary?.total_trips} type="number" />
      </div>
      <RecentTrips vehicleId={selectedVehicle?.id} isDriver scopeToday />
    </div>
  );
}